import { CommonModule } from '@angular/common';
import { Component, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';


import { InstallationService } from '../../../installations/data-access/installation.service';
import { Installation } from '../../../installations/model/installation';

@Component({
    selector: 'app-installation-input',
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
    templateUrl: './installation-input.component.html',
    styleUrl: './installation-input.component.scss'
})
export class FormlyInstallationInputComponent extends FieldType<FieldTypeConfig<FormlyFieldSelectProps>> {
  /** List of installations */
  public installations$: Signal<Installation[]> = this.installationService.dataQuery;

  constructor (private installationService: InstallationService) {
    super();
  }
}
